import { createRequest } from './createRequest'

export const profileEditPath = '/profile/edit'
export const profileEdit = createRequest({ path: profileEditPath })
